module.exports = __webpack_public_path__ + "img/bg_footer02.ed6b51e7.jpg";